var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "enhancements-time container" },
    [
      !_vm.haveIcon
        ? _c("div", { staticClass: "enhancements-image" }, [
            _c(
              "picture",
              {
                directives: [
                  {
                    name: "lazyload",
                    rawName: "v-lazyload",
                    value: {
                      src: _vm.enhancement.icon,
                      set: [
                        { width: "480", height: "240", breakpoint: "xs" },
                        { width: "800", height: "360", breakpoint: "md" },
                      ],
                      fit: "crop",
                      align: "center",
                    },
                    expression:
                      "{\n        src: enhancement.icon,\n        set: [\n          { width: '480', height: '240', breakpoint: 'xs' },\n          { width: '800', height: '360', breakpoint: 'md' }\n        ],\n        fit: 'crop',\n        align: 'center'\n      }",
                  },
                ],
                staticClass: "image-wrapper",
              },
              [
                _c("img", {
                  staticClass: "image",
                  attrs: {
                    src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                    alt: _vm.enhancement.name,
                  },
                }),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "enhancements-content-header" }, [
        _vm._v("\n    " + _vm._s(_vm.enhancement.name) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "enhancements-content-description" }, [
        _vm._v("\n    " + _vm._s(_vm.enhancement.description) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "enhancements-content-subheader",
          attrs: { id: "preferred-time-group" },
        },
        [_vm._v("\n    " + _vm._s(_vm.tc("enhancements.chooseTime")) + "\n  ")]
      ),
      _vm._v(" "),
      _c("selectable-group", {
        attrs: {
          "label-id": "preferred-time-group",
          options: _vm.options,
          "show-icon": true,
        },
        model: {
          value: _vm.selectedTime,
          callback: function ($$v) {
            _vm.selectedTime = $$v
          },
          expression: "selectedTime",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }